/** ローディング中のコンポーネント */
export const LoadingSkeleton = () => {
  return (
    <div role="status" className="max-w-[1000px] animate-pulse">
      <div className="flex flex-col gap-[24px]">
        <div className="h-[16px] bg-gray-200 rounded-[4px] dark:bg-gray-700 w-full"></div>
        <div className="h-[16px] bg-gray-200 rounded-[4px] dark:bg-gray-700 w-[80%]"></div>
        <div className="h-[16px] bg-gray-200 rounded-[4px] dark:bg-gray-700 w-[60%]"></div>
        <div className="h-[16px] bg-gray-200 rounded-[4px] dark:bg-gray-700 w-[90%]"></div>
        <div className="h-[16px] bg-gray-200 rounded-[4px] dark:bg-gray-700 w-[70%]"></div>
        <div className="h-[16px] bg-gray-200 rounded-[4px] dark:bg-gray-700 w-[50%]"></div>
        <div className="h-[16px] bg-gray-200 rounded-[4px] dark:bg-gray-700 w-[80%]"></div>
        <div className="h-[16px] bg-gray-200 rounded-[4px] dark:bg-gray-700 w-[60%]"></div>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};
